"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

/* eslint-disable */
var _default = /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    display: 'inline-block',
    width: '1em',
    height: '1em',
    verticalAlign: 'middle',
    userSelect: 'none'
  }
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0, 1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.45455 1.27277H13.3637C13.7149 1.27277 14 0.987638 14 0.636325C14 0.285129 13.7149 0 13.3637 0H4.45455C4.10323 0 3.81822 0.285129 3.81822 0.636325C3.81822 0.987638 4.10323 1.27277 4.45455 1.27277Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.636364 4.45451H13.3637C13.7149 4.45451 14 4.1695 14 3.81818C14 3.46687 13.7149 3.18186 13.3637 3.18186H0.636364C0.285051 3.18186 3.9079e-05 3.46687 3.9079e-05 3.81818C3.9079e-05 4.1695 0.285051 4.45451 0.636364 4.45451Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.45455 7.63636H13.3637C13.7149 7.63636 14 7.35123 14 7.00004C14 6.64872 13.7149 6.3636 13.3637 6.3636H4.45455C4.10323 6.3636 3.81822 6.64872 3.81822 7.00004C3.81822 7.35123 4.10323 7.63636 4.45455 7.63636Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.636364 10.8182H13.3637C13.7149 10.8182 14 10.5331 14 10.1818C14 9.83058 13.7149 9.54546 13.3637 9.54546H0.636364C0.285051 9.54546 3.9079e-05 9.83058 3.9079e-05 10.1818C3.9079e-05 10.5331 0.285051 10.8182 0.636364 10.8182Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.45455 14H13.3637C13.7149 14 14 13.715 14 13.3636C14 13.0123 13.7149 12.7273 13.3637 12.7273H4.45455C4.10323 12.7273 3.81822 13.0123 3.81822 13.3636C3.81822 13.715 4.10323 14 4.45455 14V14Z",
  fill: "black"
})));

exports["default"] = _default;
//# sourceMappingURL=alignRight.js.map